<template>
    <v-app id="inspire">
		<navigation />
		<appbar /> 
		<router-view></router-view>
    </v-app>
</template>


<script>
	import navigation from "./dashboard/navigation"
	import appbar from "./dashboard/appbar"
    export default {
		components:{
			navigation,
			appbar,
		},
        props: {
            source: String,
        },
        data: () => ({
            dialog: false,
            drawer: null,
        }),
    }
</script>